<template>
  <div>
    <a-row :gutter="20">
      <a-col :span="6" >
        语音列表
      </a-col>
      <a-col :span="18">
        <a-row :guter="20">
          <a-col :span="12" >
            原始音频
          </a-col>
          <a-col :span="12" >
            降噪后音频
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row :gutter="20">
      <a-col :span="6" >
        <div class="voice-panel left">
          <a v-for="(item,index) in data" class="item" :key="index" @click="itemClick(index)">
            {{item.url || 'xxx.mp3'}}
          </a>
        </div>
      </a-col>
      <a-col :span="18">
        <a-row :guter="20">
          <a-col :span="12" class="voice-panel">
            <div>
              <play :data="playData"></play>
            </div>
            <div>
              <img :src="current.beforePath" style="width:100%;height:200px;margin-top: 10px"/>
              <label>测试数据，无图！</label>
            </div>
          </a-col>
          <a-col :span="12" class="voice-panel">
            <div>
              <play :data="playData2"></play>
            </div>
            <div>
              <img :src="current.afterPath" style="width:100%;height:200px;margin-top: 10px"/>
              <label>测试数据，无图！</label>
            </div>
          </a-col>
        </a-row>
      </a-col>

    </a-row>
  </div>

</template>

<script>
  import Play from '@/views/project/patient/components/recording/Play'
  export default {
    name: 'Item0',
    components: { Play },
    props:{
      data:{
        type:Array,
        default:()=>{
          return []
        }
      }
    },
    data(){
      return {
        currentIndex:0,
      }
    },
    computed:{
      current(){
        if(this.data.length>0 && this.data.length-1 >= this.currentIndex){
          return this.data[this.currentIndex]
        }else{
          return {}
        }
      },
      playData(){
        return {}
      },
      playData2(){
        return {}
      }
    },
    mounted(){

    },
    methods:{
      itemClick(index){
        this.currentIndex = index
      }
    }
  }
</script>

<style scoped lang="less">
.voice-panel{
  padding: 10px
}
.left{
  min-height: 330px;
}
  .item{
    margin-top: 10px;
  }
</style>